import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import ModalPopup from '../common/ModalPopup';

const CompetiveSuccessIndex = (props) => {
    const detail = props.detail!==undefined && props.detail
    const resultDetail = props.resultDetail.summary !== undefined && props.resultDetail.summary;

    
    return (
        <>
        <div className='widget_title pdf-mt-0 pdf-pt-0  mt-4 pt-2 d-flex align-items-center justify-content-between'>
            <h3>CSI (Competitive Success Index)</h3>
            <FontAwesomeIcon icon={faInfoCircle}  data-bs-toggle="modal" data-bs-target="#csi-index"/>
        </div>
        <div className='rank_Wrapper_contain csi_IndexList'>
            {/* <div className='rank_item'>
                <h3>08</h3>
                <h5 className='rank_title'>CSI for NTSE </h5>
            </div> */}
            {detail.class_id == 7 && 
                <div className='rank_item'>
                <h3>{resultDetail!==undefined&& resultDetail.csi_for_engineering ?  resultDetail.csi_for_engineering :''}</h3>
                <h5 className='rank_title'>CSI for Engineering</h5>
            </div>
            }
            {detail.class_id ==10 && 
            <>
            <div className='rank_item'>
                <h3>{resultDetail!==undefined&& resultDetail.csi_for_pre_medical ?  resultDetail.csi_for_pre_medical :''}</h3>
                <h5 className='rank_title'>CSI for Pre-Medical</h5>
            </div>
            </>
            }

            {detail.class_id ==1 || detail.class_id ==2 || detail.class_id ==3 ?
          
            <div className='rank_item'>
                <h3>{resultDetail!==undefined&& resultDetail.csi ?  resultDetail.csi :''}</h3>
                <h5 className='rank_title'>CSI</h5>
            </div>

            :''
           
            }
            {detail.class_id ==4 || detail.class_id ==5 || detail.class_id ==6 ?
            <>
           <div className='rank_item'>
                <h3>{resultDetail!==undefined&& resultDetail.csi_for_engineering ?  resultDetail.csi_for_engineering :''}</h3>
                <h5 className='rank_title'>CSI for Engineering</h5>
            </div>
            <div className='rank_item'>
                <h3>{resultDetail!==undefined&& resultDetail.csi_for_pre_medical ?  resultDetail.csi_for_pre_medical :''}</h3>
                <h5 className='rank_title'>CSI for Pre-Medical</h5>
            </div>
            </>
            :''
            }
        </div>


        <ModalPopup id="csi-index" size="modal-sm" className="termsConditonsPopup" modalTitle="CSI (Competitive Success Index)" >
                <p>CSI or Competitive Success Index is your composite score at a scale of 10 indicating your current ability in subject knowledge, exam temperament, time management and comprehension, which is required to succeed in respective competitive examination. The test structure and complexity of TALLENTEX OVERSEAS 2022 have been drafted in such a way that CSI gets calculated by a scientific algorithm.</p>
                <p>The CSI of a student is analyzed scientifically for his/her performance on the specific day in examination hall. This CSI may vary with time and growth in student's academic level & mental aptitude in higher classes. You can improve your CSI by analyzing performance and identifying areas where you could not score at desired level</p>
          </ModalPopup>
        </>
    );
}

export default CompetiveSuccessIndex